import { render } from "./SectionEmployeeDTR.vue?vue&type=template&id=054c6532&scoped=true"
import script from "./SectionEmployeeDTR.vue?vue&type=script&lang=js"
export * from "./SectionEmployeeDTR.vue?vue&type=script&lang=js"

import "./SectionEmployeeDTR.vue?vue&type=style&index=0&id=054c6532&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054c6532"]])

export default __exports__